import * as Types from '@/types/schema';

import gql from 'graphql-tag';
import * as Urql from '@/utils/urql';
export type Omit<T, K extends keyof T> = Pick<T, Exclude<keyof T, K>>;
export type SubscriptionConfigQueryVariables = Types.Exact<{ [key: string]: never; }>;


export type SubscriptionConfigQuery = { currentWorkspace: { id: string, subscriptionConfig?: { customerId?: string | null, endDate?: string | null, type?: Types.SubscriptionTypeEnum | null } | null } };


export const SubscriptionConfigDocument = /*#__PURE__*/ gql`
    query SubscriptionConfig {
  currentWorkspace {
    id
    subscriptionConfig {
      customerId
      endDate
      type
    }
  }
}
    `;

export function useSubscriptionConfigQuery(options?: Omit<Urql.UseQueryArgs<SubscriptionConfigQueryVariables>, 'query'>) {
  return Urql.useQuery<SubscriptionConfigQuery, SubscriptionConfigQueryVariables>({ query: SubscriptionConfigDocument, ...options });
};